import React, { useState, useEffect} from 'react';
import { Heading } from '@americanexpress/dls-react';
import {
    Collapsible,
    CollapsibleHeading,
    CollapsibleContent
} from '@americanexpress/dls-react';
import parse from "html-react-parser";

function ProductHighlights({ highlights }) {

    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    if (isMobile) {
        return (
            <div>
                <div className="">
                    <Heading level="3" className="margin-2-b heading-3">PRODUCT HIGHLIGHTS</Heading>

                    <Collapsible defaultOpen={[]}>
                        <div className="">
                            <CollapsibleHeading
                                id="collapsible-text-h2"
                                labels={{
                                    collapsed: "Show Details",
                                    expanded: "Hide Details"
                                }}
                                theme={{
                                    color: '#006FCF'
                                }}
                            >
                            Click To Read +
                            </CollapsibleHeading>
                        </div>
                        <CollapsibleContent labelledBy="collapsible-text-h2">
                            <ul className="">
                                {highlights.map(highlight => (
                                    <li className="pad-1-b text-justify" key={highlight.description}>{parse(highlight.description)}</li>
                                ))}
                            </ul>
                        </CollapsibleContent>
                    </Collapsible>

                </div>
            </div>
        
        );
    }
    else {
        return (
            <div>
                <div className="stack body">
                    <Heading level="3" className="margin-2-b heading-3">PRODUCT HIGHLIGHTS</Heading>

                    <ul className="pad-1-lr">
                        {highlights.map(highlight => (
                            <li className="pad-1-b text-justify" key={highlight.description}>{parse(highlight.description)}</li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
    
}
export default ProductHighlights;